export default "__VITE_ASSET__UwHlPWuX__"